/** Portail client — réglages société. */
export type CompanyPortal = {
  enabled: boolean;
  show_invoices: boolean;
  show_quotes: boolean;
  show_credits: boolean;
  download_pdf: boolean;
  can_pay: boolean;
  can_accept_quote: boolean;
  welcome: string;
};

function asBool(v: unknown, fallback: boolean): boolean {
  if (v == null) return fallback;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  if (v === "0" || v === "false") return false;
  return Boolean(v);
}

export function portalDefaults(): CompanyPortal {
  return {
    enabled: false,
    show_invoices: true,
    show_quotes: true,
    show_credits: true,
    download_pdf: true,
    can_pay: true,
    can_accept_quote: true,
    welcome: "",
  };
}

export function portalFromCompany(row: { portal?: Partial<CompanyPortal> | null } | null | undefined): CompanyPortal {
  const d = portalDefaults();
  const src = row?.portal ?? {};
  return {
    enabled: asBool(src.enabled, d.enabled),
    show_invoices: asBool(src.show_invoices, d.show_invoices),
    show_quotes: asBool(src.show_quotes, d.show_quotes),
    show_credits: asBool(src.show_credits, d.show_credits),
    download_pdf: asBool(src.download_pdf, d.download_pdf),
    can_pay: asBool(src.can_pay, d.can_pay),
    can_accept_quote: asBool(src.can_accept_quote, d.can_accept_quote),
    welcome: String(src.welcome ?? d.welcome).slice(0, 400),
  };
}
